// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundNoise_backgroundNoiseWrapper__aXJoZ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: -1;
  pointer-events: none;
  overflow: hidden;
}

.BackgroundNoise_backgroundNoise__F8pX3 {
  position: relative;
  width: 100%;
  height: 100%;
}

.BackgroundNoise_noiseContainer__5gYjf {
  position: absolute;
  width: 100%;
  height: 100%;
}

.BackgroundNoise_leftNoise__SbEVZ {
  left: 0;
}

.BackgroundNoise_rightNoise__Rvj8h {
  right: 0;
}

.BackgroundNoise_noiseImage__SQ3Sg {
  position: absolute;
  width: 200px;
  height: auto; /* Сохраняем пропорции */
  filter: blur(1px);
  object-fit: contain;
}

/* Стили для крупных шумов по краям */
.BackgroundNoise_noiseImageLarge__2Meyy {
  position: absolute;
  width: 1024px; /* Размер больше 1024px */
  height: auto; /* Сохраняем пропорции */
  filter: blur(1px);
  object-fit: contain;
}

.BackgroundNoise_leftLarge__4Iny5 {
  transform: translateX(-50%); /* Выравниваем к левому краю */
}

.BackgroundNoise_rightLarge__ntEKf {
  transform: translateX(50%); /* Выравниваем к правому краю */
}

.BackgroundNoise_left__g56s- {
  /* Дополнительные стили для левой стороны, если нужны */
}

.BackgroundNoise_right__9QlKc {
  /* Дополнительные стили для правой стороны, если нужны */
}

.BackgroundNoise_footerNoiseContainer__oVhP\\+ {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.BackgroundNoise_footerNoise__ESGUQ {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: auto; /* Позволяем изображению иметь естественную высоту */
  filter: blur(1px);
  object-fit: contain;
}

.BackgroundNoise_contentContainer__0X5we {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
}

/* Добавим медиа-запрос для адаптации на мобильных устройствах */
@media (max-width: 768px) {
  .BackgroundNoise_noiseImage__SQ3Sg {
    width: 100px;
  }
  
  .BackgroundNoise_noiseImageLarge__2Meyy {
    width: 512px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/EntToEndUI/BackgroundNoise/BackgroundNoise.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY,EAAE,wBAAwB;EACtC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,aAAa,EAAE,yBAAyB;EACxC,YAAY,EAAE,wBAAwB;EACtC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B,EAAE,8BAA8B;AAC7D;;AAEA;EACE,0BAA0B,EAAE,+BAA+B;AAC7D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY,EAAE,oDAAoD;EAClE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,gEAAgE;AAChE;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".backgroundNoiseWrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  z-index: -1;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.backgroundNoise {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.noiseContainer {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.leftNoise {\n  left: 0;\n}\n\n.rightNoise {\n  right: 0;\n}\n\n.noiseImage {\n  position: absolute;\n  width: 200px;\n  height: auto; /* Сохраняем пропорции */\n  filter: blur(1px);\n  object-fit: contain;\n}\n\n/* Стили для крупных шумов по краям */\n.noiseImageLarge {\n  position: absolute;\n  width: 1024px; /* Размер больше 1024px */\n  height: auto; /* Сохраняем пропорции */\n  filter: blur(1px);\n  object-fit: contain;\n}\n\n.leftLarge {\n  transform: translateX(-50%); /* Выравниваем к левому краю */\n}\n\n.rightLarge {\n  transform: translateX(50%); /* Выравниваем к правому краю */\n}\n\n.left {\n  /* Дополнительные стили для левой стороны, если нужны */\n}\n\n.right {\n  /* Дополнительные стили для правой стороны, если нужны */\n}\n\n.footerNoiseContainer {\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n}\n\n.footerNoise {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: auto; /* Позволяем изображению иметь естественную высоту */\n  filter: blur(1px);\n  object-fit: contain;\n}\n\n.contentContainer {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n/* Добавим медиа-запрос для адаптации на мобильных устройствах */\n@media (max-width: 768px) {\n  .noiseImage {\n    width: 100px;\n  }\n  \n  .noiseImageLarge {\n    width: 512px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundNoiseWrapper": `BackgroundNoise_backgroundNoiseWrapper__aXJoZ`,
	"backgroundNoise": `BackgroundNoise_backgroundNoise__F8pX3`,
	"noiseContainer": `BackgroundNoise_noiseContainer__5gYjf`,
	"leftNoise": `BackgroundNoise_leftNoise__SbEVZ`,
	"rightNoise": `BackgroundNoise_rightNoise__Rvj8h`,
	"noiseImage": `BackgroundNoise_noiseImage__SQ3Sg`,
	"noiseImageLarge": `BackgroundNoise_noiseImageLarge__2Meyy`,
	"leftLarge": `BackgroundNoise_leftLarge__4Iny5`,
	"rightLarge": `BackgroundNoise_rightLarge__ntEKf`,
	"left": `BackgroundNoise_left__g56s-`,
	"right": `BackgroundNoise_right__9QlKc`,
	"footerNoiseContainer": `BackgroundNoise_footerNoiseContainer__oVhP+`,
	"footerNoise": `BackgroundNoise_footerNoise__ESGUQ`,
	"contentContainer": `BackgroundNoise_contentContainer__0X5we`
};
export default ___CSS_LOADER_EXPORT___;
